type Currency = 'NZD' | 'USD';

interface CurrencyToggleProps {
  currency: Currency;
  onChange: (currency: Currency) => void;
}

export function CurrencyToggle({ currency, onChange }: CurrencyToggleProps) {
  return (
    <div
      className="inline-flex items-center rounded-full bg-slate-800 p-1 border border-slate-700"
      role="group"
      aria-label="Currency toggle"
    >
      <button
        onClick={() => onChange('NZD')}
        className={`relative rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
          currency === 'NZD'
            ? 'text-slate-900 bg-cyan-400'
            : 'text-slate-400 hover:text-white'
        }`}
        aria-pressed={currency === 'NZD'}
      >
        NZD
      </button>
      <button
        onClick={() => onChange('USD')}
        className={`relative rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
          currency === 'USD'
            ? 'text-slate-900 bg-cyan-400'
            : 'text-slate-400 hover:text-white'
        }`}
        aria-pressed={currency === 'USD'}
      >
        USD
      </button>
    </div>
  );
}
